/*
 * Zaunkonfigurator – Shopify-Adapter.
 *
 * Löst Positionen (handle + Optionswerte) zur Laufzeit über /products/{handle}.js
 * in echte Varianten-IDs und Live-Preise auf und legt alles per cart/add.js
 * in den Warenkorb. Dadurch braucht das Datenpaket keine variant_ids und
 * die Preise sind nie veraltet.
 */
(function () {
  'use strict';

  var produktCache = {};

  function ladeProdukt(handle) {
    if (!produktCache[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      produktCache[handle] = fetch(root + 'products/' + handle + '.js')
        .then(function (r) {
          if (!r.ok) throw new Error('Produkt "' + handle + '" nicht gefunden (' + r.status + ')');
          return r.json();
        });
    }
    return produktCache[handle];
  }

  function normalisiere(s) {
    return String(s == null ? '' : s).trim().toLowerCase();
  }

  /* Variante finden, deren option1..3 den gemappten Optionswerten entsprechen. */
  function findeVariante(produkt, optionen) {
    var gesucht = optionen.map(normalisiere);
    var treffer = produkt.variants.filter(function (v) {
      var vo = [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }).map(normalisiere);
      if (vo.length !== gesucht.length) return false;
      for (var i = 0; i < vo.length; i++) {
        if (vo[i] !== gesucht[i]) return false;
      }
      return true;
    });
    return treffer[0] || null;
  }

  /*
   * Preisraster-Variante finden (Felder nach Maß): Der Optionswert der Variante
   * ist der Preis in Euro; genommen wird der exakte oder nächsthöhere Rasterwert.
   * Gleiche Logik wie im Zaunfeld-Konfigurator (feld-adapter-shopify.js).
   */
  function findePreisVariante(produkt, zielEuro) {
    var ziel = Math.round(zielEuro);
    var kandidaten = produkt.variants.map(function (v) {
      var wert = parseInt(String(v.option1 || '').replace(/[^\d]/g, ''), 10);
      return { variante: v, wert: isNaN(wert) ? null : wert };
    }).filter(function (k) { return k.wert != null; });

    var exakt = kandidaten.filter(function (k) { return k.wert === ziel; })[0];
    if (exakt) return exakt.variante;

    var hoehere = kandidaten
      .filter(function (k) { return k.wert > ziel; })
      .sort(function (a, b) { return a.wert - b.wert; })[0];
    return hoehere ? hoehere.variante : null;
  }

  function loesePositionAuf(position) {
    if (!position.handle) {
      return Promise.reject(new Error('Für "' + position.bezeichnung + '" ist kein Shop-Produkt hinterlegt.'));
    }
    return ladeProdukt(position.handle).then(function (produkt) {
      var variante;
      if (position.preisVariante) {
        variante = findePreisVariante(produkt, position.einzelpreis);
        if (!variante) {
          throw new Error('Für "' + position.bezeichnung + '" (' + Math.round(position.einzelpreis) +
            ' €) gibt es noch keine Preis-Variante am Konfigurator-Produkt – bitte Varianten-Raster erweitern.');
        }
      } else {
        variante = findeVariante(produkt, position.optionen);
        if (!variante) {
          throw new Error('Variante zu "' + position.bezeichnung + '" nicht gefunden (' + position.optionen.join(' / ') + ').');
        }
      }
      position.variantId = variante.id;
      position.einzelpreis = variante.price / 100;
      position.verfuegbar = variante.available;
      position.gesamtpreis = Math.round(position.einzelpreis * position.menge * 100) / 100;
      return position;
    });
  }

  window.ZaunShopifyAdapter = {
    /* Live-Preise für die Ergebnisanzeige nachladen. */
    holePreise: function (positionen) {
      return Promise.all(positionen.map(loesePositionAuf));
    },

    /* Alle Positionen als echte Varianten in den Warenkorb legen. */
    addToCart: function (positionen, meta) {
      return Promise.all(positionen.map(loesePositionAuf)).then(function (aufgeloest) {
        var nichtVerfuegbar = aufgeloest.filter(function (p) { return p.verfuegbar === false; });
        if (nichtVerfuegbar.length) {
          throw new Error('Leider nicht auf Lager: ' + nichtVerfuegbar.map(function (p) { return p.bezeichnung; }).join(', '));
        }
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: aufgeloest.map(function (p) {
              return { id: p.variantId, quantity: p.menge, properties: p.properties || {} };
            })
          })
        });
      }).then(function (r) {
        if (!r.ok) throw new Error('Der Warenkorb hat nicht geantwortet (' + r.status + ').');
        window.location.href = '/cart';
      });
    }
  };
}());
